<template>
  <div>
    <div class="table-box">
      <base-form
        :tableSearch="tableSearchItems"
        @change="tableFormChange"
        @search="_search"
      >
        <span slot="tableActions">
          <el-button
            size="small"
            type="primary"
            @click="exportExcel(tableCurrentQuery)"
          >
            导出数据
          </el-button>
          <el-button
            size="small"
            type="primary"
            @click="downloadReceiptBySearch"
          >
            批量下载回单
          </el-button>
        </span>
      </base-form>
      <base-table :tableColumn="tableColumn" :data="tableData" />
      <base-pagination
        v-model="tablePageQuery"
        :total="tableTotal"
        @input="_initTableData"
        :disabled="tableLoading"
      />
    </div>
  </div>
</template>
<script>
import { payOutList, payOutVoucherDownload } from '@/api/ajax';
import baseForm from '@C/Base/baseForm';
import baseTable from '@C/Base/baseTable';
import basePagination from '@C/Base/basePagination';
import dateFormat from '@/tools/dateFormat';
import { moneyFixed } from '@/tools/money';
import { getToken } from '@/tools/auth';
import baseTableMixin from '@C/Base/baseTableMixin';
import { PAY_BANK_TYPE_KEY } from '@/common/constants/bank';
import { payBankFormatter } from '@/common/fields/bank';

const INOUT_TYPE = new Map([
  [1, '收入'],
  [2, '支出']
]);

const makeOptionsByMap = map => {
  let res = [];
  map.forEach((v, k) => {
    res.push({
      label: v,
      value: k
    });
  });
  return res;
};

export default {
  name: '',
  cname: '收支列表',
  mixins: [baseTableMixin],
  components: { baseForm, baseTable, basePagination },
  data() {
    return {};
  },
  computed: {
    tableSearchParams() {
      let rep = Object.assign({}, this.tablePageQuery, this.tableSearchQuery);
      return rep;
    },
    tableSearchItems() {
      return [
        {
          type: 'select',
          label: '收支类型',
          options: makeOptionsByMap(INOUT_TYPE),
          fieldKey: 'inoutType'
        },
        {
          type: 'input',
          label: '备注',
          fieldKey: 'remark',
          placeholder: '请输入备注',
          formatter: v => {
            let res = v.slice(0, 30);
            // res = res.replace(/[^\u4e00-\u9fa5]/g, '');
            return res;
          }
        },
        {
          type: 'daterange',
          fieldKeys: ['startDt', 'endDt'],
          label: '时间',
          'start-placeholder': '开始时间',
          'end-placeholder': '结束时间'
        },
        {
          type: 'select',
          label: '收支平台',
          // 网银支付收支明细此处没有流水 不展示
          options: Object.values(this.$store.state.bank.banks).filter(
            item => item.value !== 'offLineBank'
          ),
          fieldKey: PAY_BANK_TYPE_KEY
        },
        {
          type: 'input',
          fieldKey: 'payer',
          label: '付款主体'
        },
        {
          type: 'input',
          fieldKey: 'receiver',
          label: '收款主体'
        }
      ];
    },
    tableColumn() {
      return [
        { label: '流水号', prop: 'flowingNo' },
        {
          label: '时间',
          prop: 'createDt',
          formatter: v => dateFormat(v)
        },
        {
          label: '收支类别',
          prop: 'inoutType',
          formatter: v => INOUT_TYPE.get(+v)
        },
        {
          label: '收支平台',
          prop: PAY_BANK_TYPE_KEY,
          formatter: (v, r) => {
            return payBankFormatter(r);
          }
        },
        { label: '付款主体', prop: 'payer_name' },
        { label: '收款主体', prop: 'receiver_name' },
        { label: '备注', prop: 'remark' },
        {
          label: '金额',
          prop: 'price',
          render: (h, { scope: { row } }) => {
            const { inoutType } = row;
            return h(
              'span',
              {
                style: {
                  color: +inoutType === 1 ? '#409EFF' : 'red'
                }
              },
              [
                h('span', +inoutType === 1 ? '+' : '-'),
                h('span', moneyFixed(row.price))
              ]
            );
          }
        },
        {
          label: '操作',
          render: (h, { scope: { row, _self } }) => {
            const { bankPayVoucherUrl, inoutType } = row;
            return h(
              'el-button',
              {
                props: {
                  type: 'text',
                  disabled: !bankPayVoucherUrl
                },
                on: {
                  click: () => {
                    const type = [null, '收入', '支出'][inoutType];
                    const fileName = `电子回单_${type}_${dateFormat(
                      new Date(),
                      'YYYYMMDD'
                    )}`;
                    _self.$downloadFile(bankPayVoucherUrl, false, fileName);
                  }
                }
              },
              '下载回单'
            );
          }
        }
      ];
    }
  },
  methods: {
    // 导出表格数据
    exportExcel(query) {
      if (!this.tableData.length) {
        this.$alert('没有符合当前搜索条件的数据可以导出');
        return;
      }
      let queryString = '';
      for (let paramsKey in query) {
        if (this.tableSearchQuery[paramsKey]) {
          queryString += '&' + paramsKey + '=' + query[paramsKey];
        }
      }
      this.$downloadFile(
        `/rest/cso/saas/accountsCenter/exportPayOutList?token=${getToken()}${queryString}`,
        true
      );
    },

    // 批量下载回单 （导出 搜索结果中的 数据）
    downloadReceiptBySearch() {
      const _this = this;
      let fileName = `批量下载电子回单_${dateFormat(new Date(), 'YYYYMMDD')}`;
      fileName = fileName.replace(/:/g, '-');

      // 可能会优化 嘿嘿
      this.$prompt('自定义文件名', '下载回单', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        inputValue: fileName
      })
        .then(({ value }) => {
          payOutVoucherDownload({
            zipName: value,
            ...this.tableSearchQuery
            // remark	否 备注
          }).then(() => {
            _this.$alert('文件已经在下载中心内进行生成,如需下载请前往下载中心');
            // downloadFile(fileName,url)
          });
        })
        .catch(() => {});
    },
    // 搜索 按钮
    async _search(tableQuery) {
      this.tableCurrentQuery = tableQuery;
      if (this.tableLoading) return;
      // 分页初始化
      this.tablePageQuery.pageNo = 1;
      this._initTableData();
    },
    // 初始 表格列表数据
    _initTableData() {
      if (this.tableLoading) return;
      this.tableLoading = true;
      this.$nextTick(async () => {
        const params = Object.assign(
          {},
          this.tableSearchParams,
          this.tablePageQuery
        );
        const {
          data: {
            data: { list, total }
          }
        } = await payOutList(params);
        this.tableData = list;
        this.tableTotal = total;
        this.tableLoading = false;
      });
    },
    tableFormChange(search) {
      this.tableSearchQuery = search;
    }
  },
  async created() {
    this._initTableData();
  }
};
</script>
